import { render, staticRenderFns } from "./FrontTitleComponent.vue?vue&type=template&id=4ddd60a4&scoped=true"
import script from "./FrontTitleComponent.vue?vue&type=script&lang=js"
export * from "./FrontTitleComponent.vue?vue&type=script&lang=js"
import style0 from "./FrontTitleComponent.vue?vue&type=style&index=0&id=4ddd60a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddd60a4",
  null
  
)

export default component.exports